<template>
	<div class="wrapper logistics">
		<div class="main-title">
			<div class="name">车辆信息</div>
			<el-button type="primary" class="main-btn" @click="addLogistics">添加车辆信息</el-button>
		</div>
		<el-table class="main-table" :data="tableData" border header-row-class-name="table-header" highlight-current-row
			ref="editTable">
			<el-table-column label="序号" type="index" align="center" width="80"></el-table-column>
			<el-table-column label="车牌号码" prop="plateNo" align="center"></el-table-column>
			<el-table-column label="联系人" prop="contactName" align="center"></el-table-column>
			<el-table-column label="联系电话" prop="phone" align="center"></el-table-column>
			<el-table-column label="添加时间" prop="addTime" align="center" sortable></el-table-column>
			<el-table-column label="操作" align="center" class-name="table-operate">
				<template slot-scope="{row}">
					<el-button type="primary" size="mini" round @click="exitClick(row)">编辑</el-button>
					<el-button type="danger" size="mini" round @click="deleteClick(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background layout="prev, pager, next,total,jumper" :total="total" :current-page.sync="query.page"
			:page-size="query.pagesize" @current-change="getList"></el-pagination>
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
				<el-form-item label="车牌号码" prop="plateNo">
					<el-input v-model="ruleForm.plateNo"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contactName">
					<el-input v-model="ruleForm.contactName"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
					<el-button @click="dialogVisible = false">取 消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		fetchList,
		saveOrUpdate,
		deleteLogisticsCar
	} from "@/api/logisticsCar"
	
	export default {
		data() {
			return {
				ruleForm: {
					plateNo: '',
					contactName: '',
					phone: ''
				},
				rules: {
					plateNo: [{
						required: true,
						message: '请输入车牌号码',
						trigger: 'blur'
					}],
					contactName: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请填写手机号',
						trigger: 'blur'
					}],
				},
				dialogTitle: "添加车辆信息",
				dialogVisible: false,
				tableData: [],
				total: 10,
				query: {
					keyword: '',
					page: 1,
					pagesize: 10
				}
			}
		},
		mounted() {
			this.getList()
		
		},
		methods: {
			getList(){
				fetchList(this.query).then(res => {
					this.tableData = res.data.list
					this.total = res.data.total
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						saveOrUpdate(this.ruleForm).then(res => {
							if (res.code === 0) {
								this.dialogVisible = false
								this.getList()
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			exitClick(row) {
				this.dialogTitle = "编辑车辆信息"
				this.dialogVisible = true
				this.ruleForm = row
			},
			addLogistics() {
				this.dialogTitle = "添加车辆信息"
				this.dialogVisible = true
				this.ruleForm = {
					name: '',
					contactName: '',
					phone: ''
				}
			},
			deleteClick(row) {
				this.$confirm("确定要永久删除该行数据吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.tableData.splice(row, 1)
						deleteLogisticsCar(row.id).then(res => {
							if (res.code === 0) {
								this.$message({
									type: "success",
									message: "删除成功!",
								});
								this.getList()
							}
							
						})
					})
					.catch(() => {});
			},
		}
	}
</script>

<style>
</style>
